export class MoleculePanelOverviewHeaderMultiDeactivateDnsZoneActionComponent {
    public templateUrl = require('./multi-deactivate-dns-zone-action.html?external');
}
